// import { useState, useEffect } from "react";
// import { MdLocationPin, MdStar } from "react-icons/md";
// import { FaShareAlt, FaHeart, FaRegHeart, FaUserPlus, FaUserCheck } from "react-icons/fa";
// import { Link } from "react-router-dom";
// import axios from "axios";
// import { toast } from "sonner";

// const API_URL = process.env.REACT_APP_API_URL;

// function UserEngagementFeed() {
//   const [activeTab, setActiveTab] = useState("liked"); 
//   const [jobs, setJobs] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchEngagedJobs();
//   }, [activeTab]);

//   const fetchEngagedJobs = async () => {
//     setLoading(true);
//     const token = localStorage.getItem("token");
//     const endpoint =
//       activeTab === "liked"
//         ? `${API_URL}job/liked-jobs`
//         : `${API_URL}job/following-jobs`;

//     try {
//       const res = await axios.get(endpoint, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setJobs(res.data.jobs || []);
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to load jobs");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleLike = async (jobId, currentLiked) => {
//     const token = localStorage.getItem("token");
//     try {
//       const res = await axios.post(
//         `${API_URL}job/like/${jobId}`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       setJobs((prev) =>
//         prev.map((job) =>
//           job._id === jobId
//             ? {
//                 ...job,
//                 isLiked: res.data.liked,
//                 likeCount: res.data.liked ? job.likeCount + 1 : job.likeCount - 1,
//               }
//             : job
//         )
//       );

//       if (activeTab === "liked" && !res.data.liked) {
//         setJobs((prev) => prev.filter((j) => j._id !== jobId));
//       }

//       toast.success(res.data.liked ? "Job liked!" : "Job unliked");
//     } catch (err) {
//       toast.error("Failed to update like");
//     }
//   };

//   const handleFollow = async (jobId, currentFollowing) => {
//     const token = localStorage.getItem("token");
//     try {
//       const res = await axios.post(
//         `${API_URL}job/follow/${jobId}`,
//         {},
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       setJobs((prev) =>
//         prev.map((job) =>
//           job._id === jobId
//             ? {
//                 ...job,
//                 isFollowing: res.data.followed,
//                 followCount: res.data.followed
//                   ? job.followCount + 1
//                   : job.followCount - 1,
//               }
//             : job
//         )
//       );

//       if (activeTab === "following" && !res.data.followed) {
//         setJobs((prev) => prev.filter((j) => j._id !== jobId));
//       }

//       toast.success(res.data.followed ? "Following!" : "Unfollowed");
//     } catch (err) {
//       toast.error("Failed to update follow");
//     }
//   };

//   const handleShare = (jobId, position, companyName) => {
//     const url = `${window.location.origin}/job/${jobId}`;
//     if (navigator.share) {
//       navigator.share({ title: position, text: `Job at ${companyName}`, url });
//     } else {
//       navigator.clipboard.writeText(url);
//       toast.success("Link copied!");
//     }
//   };

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center py-20">
//         <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-orange-500"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="max-w-5xl mx-auto p-4">
//       {/* Tabs */}
//       <div className="flex justify-center mb-8 border-b">
//         <button
//           onClick={() => setActiveTab("liked")}
//           className={`px-6 py-3 font-semibold text-lg transition-colors border-b-4 ${
//             activeTab === "liked"
//               ? "border-orange-500 text-orange-500"
//               : "border-transparent text-gray-600 hover:text-orange-500"
//           }`}
//         >
//           Liked Jobs ({jobs.filter(j => j.isLiked).length})
//         </button>
//         <button
//           onClick={() => setActiveTab("following")}
//           className={`px-6 py-3 font-semibold text-lg transition-colors border-b-4 ${
//             activeTab === "following"
//               ? "border-orange-500 text-orange-500"
//               : "border-transparent text-gray-600 hover:text-orange-500"
//           }`}
//         >
//           Following ({jobs.filter(j => j.isFollowing).length})
//         </button>
//       </div>

//       {/* Jobs List */}
//       {jobs.length === 0 ? (
//         <div className="text-center py-16 text-gray-500">
//           <p className="text-xl">
//             {activeTab === "liked"
//               ? "You haven't liked any jobs yet."
//               : "You're not following any jobs."}
//           </p>
//           <Link
//             to="/jobs"
//             className="mt-4 inline-block text-orange-500 hover:underline font-medium"
//           >
//             Explore Jobs
//           </Link>
//         </div>
//       ) : (
//         <div className="space-y-6">
//           {jobs.map((job) => (
//             <div
//               key={job._id}
//               className="sm:p-5 p-4 bg-white shadow-md text-sm border border-gray-200 rounded-lg relative overflow-hidden transition-transform transform hover:scale-105"
//             >
//               <div className="bg-orange-500 absolute -top-[14px] -left-[65px] w-[200px] h-[100px] rotate-[314.5deg]"></div>
//               <div className="relative z-10">
//                 <div className="z-10 absolute -top-2 right-2 bg-yellow-400 p-2 rounded-full">
//                   <MdStar className="text-white w-5 h-5" />
//                 </div>

//                 <div className="mb-4">
//                   <h1 className="text-2xl font-bold text-gray-800 capitalize">
//                     {job.jobTitle}
//                   </h1>
//                   <h2 className="text-xl capitalize text-gray-600">
//                     {job.employerName}
//                   </h2>
//                 </div>

//                 <div className="flex items-center justify-between mb-4">
//                   <div className="flex items-center text-gray-600">
//                     <MdLocationPin className="text-orange-500 mr-2" />
//                     <span>
//                       {job.state} (LGA: {job.localGovernment}, City: {job.city})
//                     </span>
//                   </div>
//                   <div className="text-gray-600">
//                     <span>Salary: {job.salary}</span>
//                   </div>
//                 </div>

//                 <div className="text-gray-600 mb-4 flex items-center justify-between flex-col sm:flex-row">
//                   <span className="font-semibold">Job Type: {job.workType}</span>
//                   {job.contactMail && (
//                     <a
//                       href={`mailto:${job.contactMail}?subject=${job.jobTitle}`}
//                       className="hover:text-orange-400 underline"
//                     >
//                       Contact: {job.contactMail}
//                     </a>
//                   )}
//                 </div>

//                 <div className="flex items-center justify-between border-t pt-4 text-gray-600">
//                   <div>
//                     <p>Experience: {job.experienceLength}</p>
//                     <p>Valid Till: {new Date(job.vacancyDuration).toLocaleDateString()}</p>
//                   </div>

//                   <div className="flex items-center gap-2">
//                     <Link
//                       to={`/job/${job._id}`}
//                       className="text-orange-500 font-semibold hover:underline"
//                     >
//                       View Job
//                     </Link>

//                     <button
//                       onClick={() => handleShare(job._id, job.jobTitle, job.employerName)}
//                       className="text-blue-500 hover:text-blue-700"
//                       title="Share"
//                     >
//                       <FaShareAlt size={18} />
//                     </button>

//                     <button
//                       onClick={() => handleLike(job._id, job.isLiked)}
//                       className={`flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium transition-all ${
//                         job.isLiked
//                           ? "bg-red-500 text-white hover:bg-red-600"
//                           : "bg-gray-200 text-gray-700 hover:bg-gray-300"
//                       }`}
//                     >
//                       {job.isLiked ? <FaHeart size={16} /> : <FaRegHeart size={16} />}
//                       <span>{job.likeCount}</span>
//                     </button>

//                     <button
//                       onClick={() => handleFollow(job._id, job.isFollowing)}
//                       className={`flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium transition-all ${
//                         job.isFollowing
//                           ? "bg-blue-600 text-white hover:bg-blue-700"
//                           : "bg-gray-200 text-gray-700 hover:bg-gray-300"
//                       }`}
//                     >
//                       {job.isFollowing ? <FaUserCheck size={16} /> : <FaUserPlus size={16} />}
//                       <span>{job.followCount}</span>
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// export default UserEngagementFeed;






import { useState, useEffect } from "react";
import { MdLocationPin, MdStar } from "react-icons/md";
import { FaShareAlt, FaHeart, FaRegHeart, FaUserPlus, FaUserCheck } from "react-icons/fa";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

const API_URL = process.env.REACT_APP_API_URL;

function UserEngagementFeed() {
  const [activeTab, setActiveTab] = useState("liked");

  // FIX: separate state per tab instead of one shared `jobs` array.
  // Previously, switching tabs replaced the *entire* jobs array with
  // whatever the new endpoint returned, so the header counts — which
  // were both computed by filtering that same single array — lost
  // visibility into whichever tab's data wasn't just fetched.
  const [likedJobs, setLikedJobs] = useState([]);
  const [followingJobs, setFollowingJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchEngagedJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const fetchEngagedJobs = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    const endpoint =
      activeTab === "liked"
        ? `${API_URL}job/liked-jobs`
        : `${API_URL}job/following-jobs`;

    try {
      const res = await axios.get(endpoint, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // FIX: write into the list that matches the tab just fetched,
      // never into a single shared array.
      if (activeTab === "liked") {
        setLikedJobs(res.data.jobs || []);
      } else {
        setFollowingJobs(res.data.jobs || []);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to load jobs");
    } finally {
      setLoading(false);
    }
  };

  // The list currently rendered below the tabs.
  const jobs = activeTab === "liked" ? likedJobs : followingJobs;

  // Helper to update whichever list(s) currently hold this job, so a
  // like/follow action stays in sync across both tabs without needing
  // a re-fetch.
  const updateJobInBothLists = (jobId, updater) => {
    setLikedJobs((prev) => prev.map((j) => (j._id === jobId ? updater(j) : j)));
    setFollowingJobs((prev) => prev.map((j) => (j._id === jobId ? updater(j) : j)));
  };

  const handleLike = async (jobId, currentLiked) => {
    const token = localStorage.getItem("token");
    try {
      const res = await axios.post(
        `${API_URL}job/like/${jobId}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      updateJobInBothLists(jobId, (job) => ({
        ...job,
        isLiked: res.data.liked,
        likeCount: res.data.liked ? job.likeCount + 1 : job.likeCount - 1,
      }));

      if (activeTab === "liked" && !res.data.liked) {
        setLikedJobs((prev) => prev.filter((j) => j._id !== jobId));
      }

      toast.success(res.data.liked ? "Job liked!" : "Job unliked");
    } catch (err) {
      toast.error("Failed to update like");
    }
  };

  const handleFollow = async (jobId, currentFollowing) => {
    const token = localStorage.getItem("token");
    try {
      const res = await axios.post(
        `${API_URL}job/follow/${jobId}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      updateJobInBothLists(jobId, (job) => ({
        ...job,
        isFollowing: res.data.followed,
        followCount: res.data.followed ? job.followCount + 1 : job.followCount - 1,
      }));

      if (activeTab === "following" && !res.data.followed) {
        setFollowingJobs((prev) => prev.filter((j) => j._id !== jobId));
      }

      toast.success(res.data.followed ? "Following!" : "Unfollowed");
    } catch (err) {
      toast.error("Failed to update follow");
    }
  };

  const handleShare = (jobId, position, companyName) => {
    const url = `${window.location.origin}/job/${jobId}`;
    if (navigator.share) {
      navigator.share({ title: position, text: `Job at ${companyName}`, url });
    } else {
      navigator.clipboard.writeText(url);
      toast.success("Link copied!");
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center py-20">
        <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-orange-500"></div>
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto p-4">
      {/* Tabs */}
      <div className="flex justify-center mb-8 border-b">
        <button
          onClick={() => setActiveTab("liked")}
          className={`px-6 py-3 font-semibold text-lg transition-colors border-b-4 ${
            activeTab === "liked"
              ? "border-orange-500 text-orange-500"
              : "border-transparent text-gray-600 hover:text-orange-500"
          }`}
        >
          {/* FIX: count from the dedicated likedJobs list, not the
              currently-displayed `jobs` list. */}
          Liked Jobs ({likedJobs.filter((j) => j.isLiked).length})
        </button>
        <button
          onClick={() => setActiveTab("following")}
          className={`px-6 py-3 font-semibold text-lg transition-colors border-b-4 ${
            activeTab === "following"
              ? "border-orange-500 text-orange-500"
              : "border-transparent text-gray-600 hover:text-orange-500"
          }`}
        >
          {/* FIX: count from the dedicated followingJobs list. */}
          Following ({followingJobs.filter((j) => j.isFollowing).length})
        </button>
      </div>

      {/* Jobs List */}
      {jobs.length === 0 ? (
        <div className="text-center py-16 text-gray-500">
          <p className="text-xl">
            {activeTab === "liked"
              ? "You haven't liked any jobs yet."
              : "You're not following any jobs."}
          </p>
          <Link
            to="/jobs"
            className="mt-4 inline-block text-orange-500 hover:underline font-medium"
          >
            Explore Jobs
          </Link>
        </div>
      ) : (
        <div className="space-y-6">
          {jobs.map((job) => (
            <div
              key={job._id}
              className="sm:p-5 p-4 bg-white shadow-md text-sm border border-gray-200 rounded-lg relative overflow-hidden transition-transform transform hover:scale-105"
            >
              <div className="bg-orange-500 absolute -top-[14px] -left-[65px] w-[200px] h-[100px] rotate-[314.5deg]"></div>
              <div className="relative z-10">
                <div className="z-10 absolute -top-2 right-2 bg-yellow-400 p-2 rounded-full">
                  <MdStar className="text-white w-5 h-5" />
                </div>

                <div className="mb-4">
                  <h1 className="text-2xl font-bold text-gray-800 capitalize">
                    {job.jobTitle}
                  </h1>
                  <h2 className="text-xl capitalize text-gray-600">
                    {job.employerName}
                  </h2>
                </div>

                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center text-gray-600">
                    <MdLocationPin className="text-orange-500 mr-2" />
                    <span>
                      {job.state} (LGA: {job.localGovernment}, City: {job.city})
                    </span>
                  </div>
                  <div className="text-gray-600">
                    <span>Salary: {job.salary}</span>
                  </div>
                </div>

                <div className="text-gray-600 mb-4 flex items-center justify-between flex-col sm:flex-row">
                  <span className="font-semibold">Job Type: {job.workType}</span>
                  {job.contactMail && (
                    <a
                      href={`mailto:${job.contactMail}?subject=${job.jobTitle}`}
                      className="hover:text-orange-400 underline"
                    >
                      Contact: {job.contactMail}
                    </a>
                  )}
                </div>

                <div className="flex items-center justify-between border-t pt-4 text-gray-600">
                  <div>
                    <p>Experience: {job.experienceLength}</p>
                    <p>Valid Till: {new Date(job.vacancyDuration).toLocaleDateString()}</p>
                  </div>

                  <div className="flex items-center gap-2">
                    <Link
                      to={`/job/${job._id}`}
                      className="text-orange-500 font-semibold hover:underline"
                    >
                      View Job
                    </Link>

                    <button
                      onClick={() => handleShare(job._id, job.jobTitle, job.employerName)}
                      className="text-blue-500 hover:text-blue-700"
                      title="Share"
                    >
                      <FaShareAlt size={18} />
                    </button>

                    <button
                      onClick={() => handleLike(job._id, job.isLiked)}
                      className={`flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium transition-all ${
                        job.isLiked
                          ? "bg-red-500 text-white hover:bg-red-600"
                          : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                      }`}
                    >
                      {job.isLiked ? <FaHeart size={16} /> : <FaRegHeart size={16} />}
                      <span>{job.likeCount}</span>
                    </button>

                    <button
                      onClick={() => handleFollow(job._id, job.isFollowing)}
                      className={`flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium transition-all ${
                        job.isFollowing
                          ? "bg-blue-600 text-white hover:bg-blue-700"
                          : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                      }`}
                    >
                      {job.isFollowing ? <FaUserCheck size={16} /> : <FaUserPlus size={16} />}
                      <span>{job.followCount}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default UserEngagementFeed;